import { render, staticRenderFns } from "./EditarBeneficiarioImportacaoList.vue?vue&type=template&id=4b36edea&scoped=true"
import script from "./EditarBeneficiarioImportacaoList.vue?vue&type=script&lang=js"
export * from "./EditarBeneficiarioImportacaoList.vue?vue&type=script&lang=js"
import style0 from "./EditarBeneficiarioImportacaoList.vue?vue&type=style&index=0&id=4b36edea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b36edea",
  null
  
)

export default component.exports